var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommentsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4663 27.0899L6.0199 33.1098V9.03036C6.0199 8.63121 6.17846 8.24842 6.46069 7.96619C6.74293 7.68395 7.12572 7.52539 7.52486 7.52539H31.6043C32.0035 7.52539 32.3863 7.68395 32.6685 7.96619C32.9507 8.24842 33.1093 8.63121 33.1093 9.03036V25.585C33.1093 25.9841 32.9507 26.3669 32.6685 26.6492C32.3863 26.9314 32.0035 27.0899 31.6043 27.0899H13.4663Z",
    stroke: "black",
    strokeWidth: 3.00993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0497 27.0894V34.6143C15.0497 35.0134 15.2082 35.3962 15.4905 35.6784C15.7727 35.9607 16.1555 36.1192 16.5546 36.1192H34.6927L42.1391 42.1391V18.0597C42.1391 17.6605 41.9805 17.2777 41.6983 16.9955C41.416 16.7132 41.0332 16.5547 40.6341 16.5547H33.1093",
    stroke: "black",
    strokeWidth: 3.00993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentsBlack);
export default __webpack_public_path__ + "static/media/icon-comments-black.d10632ae4976ab669187cf9cb9953674.svg";
export { ForwardRef as ReactComponent };